import React from 'react'

const DropdownInput = ({index, name, fieldname, onChange, value, dropdownValues}) => {
    const TYPE = "dropdown";
    
    const handleInputChange = (event) => {
        onChange(event, TYPE, fieldname);
    };

    const handleClear = () => {
        const event = { target: { value: "" } };
        onChange(event, TYPE, fieldname);
    };

    return (
    <div className="side-input mt-2 mb-2">
        <label className="mb-0 w-100" htmlFor={`dropdown-${index}`}>{name}
            <div className="input-group">
                <select value={value ?? ""} onChange={e => handleInputChange(e)} className="custom-select" id={`dropdown-${index}`}>
                    <option value="">Select {name}</option>
                    {dropdownValues.map((option, i) => (
                        <option key={i} value={option}>{option}</option>
                    ))}
                </select>
                {value && (
                <div className="input-group-append">
                    <button className="btn btn-outline-secondary" 
                    type="button"
                    onClick={handleClear}>×</button>
                </div>
                )}
            </div>
        </label>
    </div>
    )
}

export default DropdownInput